/**
 * rmh
 * 2018.08.30
 * 签署证据相关，删除，上传图片视频等
 */

import Vue from 'vue'
import HttpAxios from "./http-axios";
import GlobalConfig from '../config/global'
import ApiPort from "../config/api-port";
import {handleError} from '../lib/common';
import {postTempFileOper} from './http-methods';

let junziqianApi = GlobalConfig.domain.junziqianApi
let domain = GlobalConfig.domain
let portal = GlobalConfig.domain.portal

export default {
  presCntAndMnt(){
    let url = junziqianApi + ApiPort.blockChain.presCntAndMnt
    return HttpAxios.get(url)
  },
  presChainDetail(e,img,imgcode) {
    let url = junziqianApi + ApiPort.blockChain.presChainDetail + '/' + e + '?needImg=' + img + '&imgCode=' + imgcode
    return HttpAxios.get(url)
  },
  /**
   * 上传pdf文件校验
   * @file file文件
   * */
  validateContract(file) {
    let url = junziqianApi + ApiPort.blockChain.validateContract
    let formData = new FormData;
    formData.append('file', file);
    return HttpAxios.postForm(url, formData)
  },
  /**
  * 保全链查询
  * */
  getChainNodeTree() {
    let url = portal + ApiPort.blockChain.chainNodeTree
    return HttpAxios.get(url)
  },
  getChainNodeList(code) {
    let url = portal + ApiPort.blockChain.chainNodeList + '?code=' + code
    return HttpAxios.get(url)
  }
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/blockChain.js